import { makeStyles, Theme } from "@material-ui/core/styles";

interface IStylesProps {
  backgroundColor: string;
}

export default makeStyles<Theme, IStylesProps>((theme: Theme) => ({
  weatherInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FBFBFB",
    padding: "12px 16px",
    borderTop: "1px solid #eeeeee",
    borderBottom: "1px solid #eeeeee",
    "&:first-child": {
      borderTop: "none"
    },
    [theme.breakpoints.up("md")]: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      padding: "7px 16px",
      borderTop: `1px solid ${theme.palette.text.hint}`,
      borderBottom: `1px solid ${theme.palette.text.hint}`
    }
  },
  weekDay: {
    textTransform: "uppercase",
    fontSize: 14,
    lineHeight: 1,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.primary,
    marginBottom: "6px",
    "& > span": {
      fontFamily: "SuisseIntlRegular",
      color: theme.palette.text.secondary
    },
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  weekDayShort: {
    whiteSpace: "nowrap",
    fontSize: 13,
    lineHeight: 1,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.primary,
    textTransform: "uppercase",
    "& > span": {
      fontFamily: "SuisseIntlRegular",
      color: theme.palette.text.secondary
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  weekDayLocationContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  location: {
    position: "absolute",
    right: 0,
    marginBottom: "6px",
    display: "flex",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  locationIcon: {
    fontSize: "14px",
    opacity: 0.3,
    color: ({ backgroundColor }) => `#${backgroundColor}`
  },
  locationName: {
    fontSize: "10px",
    color: "rgba(186, 186, 186, 0.5)",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  indicators: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: "22px",
    "& > * + *": {
      marginLeft: "24px"
    },
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  picWrapper: {
    overflow: "hidden",
    height: "100%",
    display: "flex",
    alignItems: "center",
    minWidth: "24px",
    backgroundColor: "transparent",
    "& > img": {
      height: "100%",
      width: "100%"
    }
  },
  temperature: {
    fontSize: 14,
    lineHeight: 1
  },
  temperatureDay: {
    color: theme.palette.text.primary,
    margin: "0 2px"
  },
  temperatureNight: {
    color: theme.palette.text.secondary,
    margin: "0 2px"
  },
  humidity: {
    width: "100%",
    height: "100%",
    position: "relative",
    backgroundColor: "#fff",
    [theme.breakpoints.down("xs")]: {
      height: 14
    }
  },
  humidityPercent: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    background: "rgba(99, 217, 255, 1)"
  },
  humidityText: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    fontSize: 12,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
      paddingLeft: 8,
      paddingTop: 1
    }
  },
  humidityIcon: {
    position: "absolute",
    top: 1,
    left: 2,
    zIndex: 1,
    fontSize: 13,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
      left: 0
    }
  },
  outOfServiceText: {
    display: "flex",
    height: "100%",
    color: theme.palette.primary.light,
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    fontSize: 12,
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  }
}));
